import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromError } from './reducers';
import { Error, ErrorOptions } from './models';
import { errorActions } from './actions';
import { WebAngularSharedUtilErrorHandlingConfig, WebAngularSharedUtilErrorHandlingOptions } from './error-handling-config';

@Injectable()
export class ErrorDispatchService {
  constructor(
    private store: Store<fromError.State>,
    @Inject(WebAngularSharedUtilErrorHandlingConfig) private errorHandlingOptions: WebAngularSharedUtilErrorHandlingOptions
  ) {}

  dispatch(errorInput: Error | ErrorOptions | string): void {
    this.store.dispatch(new errorActions.Add(errorInput));
  }

  getRedirectRoute(error: Error): string {
    if (error.redirect) {
      return error.redirectRoute || this.errorHandlingOptions.errorRedirectRoute;
    }
    return undefined;
  }
}
